import { RatingType } from '@/components/Form';
import {
  adaptDatabaseFieldFunction,
  adaptFormFieldFunction,
  parseFormDataFunction,
} from '@/modules/corporate/modules/database/fields/types';
import { DatabaseRatingTypeEnum } from '@/types/schema';

import { getRatingMaxValue } from './consts';

export const parseFormData: parseFormDataFunction = (data: number | string) => ({
  value: data.toString(),
});

export const adaptFormField: adaptFormFieldFunction = ({ field }) => ({
  props: {
    ratingType: field.metadataField.ratingType as unknown as RatingType,
    max: getRatingMaxValue(field.metadataField.validation?.maxValue),
    maxLabel: field.viewField.maxLabel ?? '',
    minLabel: field.viewField.minLabel ?? '',
  },
});

export const adaptRatingField: adaptDatabaseFieldFunction = ({ metadataField, viewField }) => {
  const maxValue = getRatingMaxValue(metadataField.validation?.maxValue);

  return {
    metadataField: {
      ...metadataField,
      ratingType: metadataField.ratingType || DatabaseRatingTypeEnum.Star,
      validation: { maxValue },
    },
    viewField,
  };
};
